<template>
  <div class="free-number-container">
    <div class="header">
      <checkout-headline :title="$t('checkout.freeNumber.title')" :text="$t('checkout.freeNumber.text')"/>
    </div>
    <NumberSlider v-if="load"
                  :numbersList="numbers"
                  @phoneNumber="addNum"
                  :slides="slides"
                  :cartData="cartData"/>
    <div>
      <div class="button-box-container">
        <div class="jmbg-text"> {{ $t('checkout.freeNumber.jmbgText') }}</div>
        <validation-observer ref="jmbgInput"
                             tag="form"
                             @submit.prevent="submitNewNumber">
          <BaseVInput v-model="jmbg"
                      type="number"
                      rules="required|digits:13|jmbg"
                      class="jmbg-input"
                      pattern="\d*"
                      :label="$t('checkout.freeNumber.jmbgLabel')"
                      :submitted="formSubmitted"/>
        </validation-observer>
      </div>
      <div class="actions-container">
        <div v-if="eSim" class="checkbox-container">
          <BaseCheckbox v-model="eSimCheck"
                        class="checkbox-label"
                        :label="$t('checkout.freeNumber.activateEsim')"
                        :value="eSimCheck"/>
        </div>
        <div class="btn">
          <BaseButton block
                      :disabled="!mobileNumber"
                      @click="submitNewNumber">
            {{ $t('checkout.freeNumber.continue') }}
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import { checkoutViews } from '../config/checkoutViews'
import CheckoutHeadline from '@/components/checkout/checkout-headline'
import BaseVInput from '@/components/base/base-v-input'
import BaseButton from '@/components/base/base-button'
import BaseCheckbox from '@/components/base/base-checkbox'
import NumberSlider from './numbers-slider'
import { getFreeNumbers, addMsisdn } from '@/api/checkout'
import cartComponentsProps from '../config/cartComponentsProps'

export default {
  name: 'user-identification-free-number',
  components: { BaseVInput, BaseButton, NumberSlider, BaseCheckbox, CheckoutHeadline },
  props: { ...cartComponentsProps },
  data () {
    return {
      slides: 0,
      active: 1,
      numbers: [],
      load: false,
      jmbg: '',
      eSimCheck: false,
      mobileNumber: '',
      numberSubmited: false,
      eSim: true,
      formSubmitted: false
    }
  },
  mounted () {
    this.getNumberOfPages()
  },
  watch: {
    cartData (cartData) {
      this.getNumberOfPages(cartData.guid)
    }
  },
  methods: {
    updateComponent (payload) {
      this.$emit('update-component', payload)
    },
    addNum (num) {
      this.mobileNumber = num
    },
    getNumberOfPages (guid) {
      const query = {
        cartId: this.cartData.guid,
        page: 1
      }
      getFreeNumbers(query).then(res => {
        this.eSim = res.data.esim
        this.slides = res.data.msisdnList.pagination.numberOfPages
        this.numbers = res.data.msisdnList.results.map(num => {
          return {
            number: num.subscriberIdentity,
            checked: false
          }
        })
        this.load = true
      })
    },
    async submitNewNumber () {
      const valid = await this.$refs.jmbgInput.validate()
      this.formSubmitted = true
      if (valid) {
        const params = {
          cartId: this.cartData.guid,
          jmbg: this.jmbg,
          msisdn: this.mobileNumber,
          eSim: this.eSimCheck
        }
        addMsisdn(params).then(res => {
          if (res.status === 201) {
            this.numberSubmited = true
            this.$emit('update-component', checkoutViews.checkoutPreview.name)
          }
        }).catch(() => {
          this.toast('error', {
            message: this.$t('checkout.existingNumber.errMessages.error')
          })
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.header {
  padding: 4.8rem 0;
  display: flex;
  flex-direction: column;
  background-color: $light-grey;

  @media (map_get($breakpoints, sm)) {
    margin-top: 40px;
    text-align: center;
  }

  h1 {
    color: $black;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 15px;
    @media (map_get($breakpoints, sm)) {
      font-size: 32px;
      line-height: 1.31;
      font-weight: normal;
      margin-bottom: 10px;
    }
  }

  span {
    font-size: 14px;
    color: $light-black;
    @media (map_get($breakpoints, sm)) {
      font-size: 16px;
    }
  }
}

.slider-container {
  height: 40vh;
}

.free-number-container {
  @media (map_get($breakpoints, sm)) {
    padding: 0 4rem;
  }

  @media (map_get($breakpoints, md)) {
    padding: 0 11rem;
  }

  @media (map_get($breakpoints, lg)) {
    padding: 0 13rem;
  }

  @media (map_get($breakpoints, lg)) {
    margin: 0 auto;
    max-width: 108rem;
  }
}

.checkbox-container {
  margin-top: -10px;
  display: flex;
  align-items: center;

  @media (map_get($breakpoints, sm)) {
    padding: 0 0;
    margin-left: 25px;
  }

  span {
    padding-left: 10px;
    font-size: 12px;
  }

  .checkbox-label {
    color: $light-black;
  }
}

.jmbg-container {
  padding: 0 2.4rem;

  @media (map_get($breakpoints, sm)) {
    padding: 40px 0 0;
    border-top: 1px solid $grey;
    width: 100%;
    display: flex;
    div {
      margin-bottom: 0;
    }
  }
}

.jmbg-input {
  @media (map_get($breakpoints, sm)) {
    width: 260px;
  }
  @media (map_get($breakpoints, md)) {
    width: 315px;
  }
}

.button-box-container {
  background-color: $white;
  padding: 0 2.4rem;

  @media (map_get($breakpoints, sm)) {
    display: flex;
    flex-direction: column;
    padding: 0 7.4rem 3rem;
    justify-content: space-between;
  }
  @media (map_get($breakpoints, md)) {
    padding: 0 9.4rem 3rem;
  }
}

.btn {
  //padding: 0 2.4rem;
  margin-top: 15px;

  @media (map_get($breakpoints, exsm)) {
    margin-top: 0;
  }

  @media (map_get($breakpoints, sm)) {
    padding: 0 0;
    margin-top: 0;

    .base-button.size-normal {
      width: 180px;
    }
  }
}

.actions-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background-color: $white;
  margin-bottom: 3rem;
  padding: 2.4rem;

  @media (map_get($breakpoints, exsm)) {
    flex-direction: row;
  }

  @media (map_get($breakpoints, sm)) {
    padding: 0 7.4rem 3rem;
  }
}

</style>
